import { i18n } from 'lib/i18n.js';
import validate from 'mixins/validate';
import signups from 'mixins/signups';
import { pushDataSubscription } from 'lib/tracking';

export default {
  components: {
    'text-input': () => import('../text-input/text-input.vue'),
  },
  data: () => ({
    acceptMarketing: true,
    phoneSendSMS: true,
    emailValue: '',
    emailError: '',
    phoneValue: '',
    phoneError: '',
  }),
  i18n,
  props: {
    baseUrl: { default: '', type: String },
    klaviyoListId: { default: '', type: String },
  },
  mixins: [validate, signups],
  mounted() {
    window.addEventListener('sign-up:success', this.emitSuccess);
  },
  computed: {
    attentiveCreativeId() {
      const shop = window.Shopify && window.Shopify.shop;
      switch (shop) {
        case 'fenty-beauty-uk.myshopify.com':
          return '1012207';
        case 'fenty-uk-staging.myshopify.com':
          return '1012207';
        default:
          return '66105';
      }
    },
  },
  methods: {
    onEmailSubmit() {
      this.klavioSignup();
    },
    onPhoneSubmit() {
      this.attentiveSignup();
    },
    onEmailChange({ value }) {
      this.emailValue = value;
    },
    onPhoneChange({ value }) {
      const ev = event;
      this.phoneValue = value;
      const formattedValue = this.formatAsPhoneNumber(this.phoneValue);
      const inputEl = this.$refs.phoneInput.$el;

      // Temporary comment out to prevent phone number from being formatted in the input field
      // if (inputEl) {
      //   setTimeout(() => {
      //     if (
      //       ev?.inputType !== 'deleteContentBackward' &&
      //       ev?.inputType !== 'deleteContentForward'
      //     )
      //       inputEl.querySelector('input[name="phone"]').value = formattedValue;
      //   }, 10);
      // }
    },
    formatAsPhoneNumber(value) {
      const cleanedValue = value.replace(/\D/g, '');

      // Check the length to determine if country code is needed
      let formattedValue = '';

      if (cleanedValue.length === 10) {
        // US/Canada number without country code
        const x = cleanedValue.match(/(\d{3})(\d{3})(\d{4})/);
        formattedValue = `+1 (${x[1]}) ${x[2]} - ${x[3]}`;
      } else if (cleanedValue.length === 11 && cleanedValue.startsWith('1')) {
        // US/Canada number with country code
        const x = cleanedValue.match(/(\d{1})(\d{3})(\d{3})(\d{4})/);
        formattedValue = `+${x[1]} (${x[2]}) ${x[3]} - ${x[4]}`;
      } else if (cleanedValue.length === 11 && cleanedValue.startsWith('44')) {
        // UK number without country code
        const x = cleanedValue.match(/(\d{2})(\d{4})(\d{6})/);
        formattedValue = `+${x[1]} ${x[2]} ${x[3]}`;
      } else if (cleanedValue.length === 12 && cleanedValue.startsWith('44')) {
        // UK number with country code
        const x = cleanedValue.match(/(\d{2})(\d{4})(\d{6})/);
        formattedValue = `+${x[1]} ${x[2]} ${x[3]}`;
      } else {
        // For other cases, just format the digits as is
        const x = cleanedValue.match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        formattedValue = `${x[1] ? `( ${x[1]} ) ` : ''}${x[2]}${x[3] ? ` - ${x[3]}` : ''}`;
      }

      return formattedValue;
    },
    emitSuccess() {
      this.$emit('success', null);
    },
    klavioSignup() {
      if (!this.emailValue) {
        this.emailError = this.$t('general.form_errors.required');

        window.dataLayer.push({
          event: 'error_captured',
          error_message: `(email signup) ${this.emailError?.toLowerCase()}`,
        });

        return;
      }
      const result = this.validateEmail({ value: this.emailValue });
      if (result.valid !== true) {
        this.emailError = result.message;

        window.dataLayer.push({
          event: 'error_captured',
          error_message: `(email signup) ${result.message?.toLowerCase()}`,
        });
        return;
      }
      this.emailError = '';

      this.submitToKlaviyo({
        listId: this.klaviyoListId,
        email: this.emailValue,
        acceptMarketing: this.acceptMarketing,
      }).then(() => {
        this.emitSuccess();
        this.resetValues();
        pushDataSubscription('Email', 'footer', 'footer signup');
      });
    },
    attentiveSignup() {
      const phoneValue = this.phoneValue.replace(/[()-\s]/g, '');
      const result = this.validatePhone({ value: phoneValue });

      if (result.valid !== true) {
        this.phoneError = result.message;

        window.dataLayer.push({
          event: 'error_captured',
          error_message: `(phone signup) ${this.phoneError?.toLowerCase()}`,
        });

        return;
      }
      this.phoneError = '';

      this.submitToAttentive(this.attentiveCreativeId).then(() => {
        this.emitSuccess();
        this.resetValues();
        pushDataSubscription('Phone number', 'footer', 'footer signup');
      });
    },
    resetValues() {
      this.validatableFields.forEach((field) => {
        if (field.inputValue) {
          field.inputValue = '';
        }
      });
    },
    makePageTplTitle() {
      const splitSurfix = 'page.';
      if (__GLOBAL__.template.includes(splitSurfix)) {
        return (
          __GLOBAL__.template.split(splitSurfix)[1].replaceAll('-', ' ') +
          ' page'
        );
      } else {
        return __GLOBAL__.template;
      }
    },
  },
};
